module.exports = __webpack_public_path__ + "static/media/189.8094fc20.jpg";